import http, { getToken } from '../../api/http';

/* REST chata (/API/chat/*). Greške prikazuje http.js (toast "Greška" sa tekstom servera). */
const d = (r) => r.data;
const post = (putanja, telo, cfg) => http.post(`/chat${putanja}`, telo || {}, cfg).then(d);

const posaljiFajl = (putanja, fajl, ime, polja = {}) => {
    const fd = new FormData();
    if (fajl) fd.append('fajl', fajl, ime || fajl.name);
    Object.entries(polja).forEach(([k, v]) => fd.append(k, v));
    return http.post(`/chat${putanja}`, fd).then(d);
};

export const chatApi = {
    korisnici: () => post('/korisnici'),
    profil: () => post('/profil'),
    razgovori: () => post('/razgovori'),
    neprocitano: () => post('/neprocitano', {}, { silent: true }),
    poruke: (telo) => post('/poruke', telo),
    posalji: (telo) => post('/posalji', telo),
    izmeni: (porukaId, sadrzaj) => post('/izmeni', { porukaId, sadrzaj }),
    obrisi: (porukaIds) => post('/obrisi', { porukaIds }),
    reakcija: (porukaId, emoji) => post('/reakcija', { porukaId, emoji }),
    glasaj: (porukaId, opcijaId) => post('/glasaj', { porukaId, opcijaId }),
    anketa: (razgovorId, pitanje, opcije) => post('/anketa', { razgovorId, pitanje, opcije }),
    dogadjaj: (telo) => post('/dogadjaj', telo),
    prosledi: (porukaId, ciljevi) => post('/prosledi', { porukaId, ciljevi }),
    noviDm: (saKorisnikId) => post('/novi-dm', { saKorisnikId }),
    novaGrupa: (naziv, clanovi) => post('/nova-grupa', { naziv, clanovi }),
    grupaInfo: (razgovorId) => post('/grupa-info', { razgovorId }),
    dodajClana: (razgovorId, korisnici) => post('/dodaj-clana', { razgovorId, korisnici }),
    ukloniClana: (razgovorId, saKorisnikId) => post('/ukloni-clana', { razgovorId, saKorisnikId }),
    napusti: (razgovorId) => post('/napusti', { razgovorId }),
    preimenuj: (razgovorId, naziv) => post('/preimenuj', { razgovorId, naziv }),
    obrisiRazgovor: (razgovorId) => post('/obrisi-razgovor', { razgovorId }),
    oznaciNeprocitano: (razgovorId) => post('/oznaci-neprocitano', { razgovorId }),
    procitaj: (razgovorId) => post('/procitaj', { razgovorId }, { silent: true }),
    citaoci: (porukaId) => post('/citaoci', { porukaId }),
    zakaci: (porukaId, zakaci) => post('/zakaci', { porukaId, zakaci }),
    zakacene: (razgovorId) => post('/zakacene', { razgovorId }, { silent: true }),
    sacuvaj: (porukaIds, sacuvaj) => post('/sacuvaj', { porukaIds, sacuvaj }),
    sacuvane: () => post('/sacuvane'),
    pretraga: (razgovorId, q) => post('/pretraga', { razgovorId, q }, { silent: true }),
    kuca: (razgovorId, ime, prestao) => post('/kuca', { razgovorId, ime, prestao }, { silent: true }),
    prisustvo: (stanje) => post('/prisustvo', { stanje }, { silent: true }),
    gif: (q) => post('/gif', { q }),
    prilog: (fajl, ime) => posaljiFajl('/prilog', fajl, ime),
    avatar: (fajl) => posaljiFajl('/avatar', fajl),
    avatarGrupe: (razgovorId, fajl) => posaljiFajl('/avatar-grupe', fajl, undefined, { razgovorId }),
};

const BASE = process.env.REACT_APP_BACKEND_URL || '';

/** adresa priloga / avatara (img i a ne šalju zaglavlja, pa token ide u upitu) */
export const prilogUrl = (id, preuzmi = false) => (id
    ? `${BASE}/API/chat/prilog/${id}?t=${encodeURIComponent(getToken() || '')}${preuzmi ? '&preuzmi=1' : ''}`
    : null);
